import { z } from 'zod';
import { zDbId } from '~/plugins/zod/utils';
import { AppUserSimpleSchema, PartnerSimpleSchema } from '../links/_types';
import { AddressType } from '~/enums/_types';
import { CurrencyCodeSchema } from '../_types';

export const PartnerInfoSchema = PartnerSimpleSchema.and(
    z.object({
        IsActive: z.boolean(),
        CompanyNumber: z.string().nullable(),
        TaxCode: z.string().nullable(),
        DiscountGroupCode: z.string().nullable(),
        Dealer: AppUserSimpleSchema.nullish(),
        ShipType: z.string().nullable(),
    })
);

export const PartnerDetailSchema = PartnerInfoSchema.and(
    z.object({
        Currency: CurrencyCodeSchema,
        GroupNumber: z.string().nullable(),
    })
);

export const AddressSimpleSchema = z.object({
    Id: zDbId(),
    Type: z.nativeEnum(AddressType),
    Street: z.string().nullable(),
    City: z.string().nullable(),
    Country: z.string(),
    Zip: z.string().nullable(),
    IsDefault: z.boolean(),
});

export const FetchPartnersResponseSchema = z.array(PartnerInfoSchema);
export const FetchAddressesResponseSchema = z.array(AddressSimpleSchema);
export const FetchEnumPartnersResponseSchema = z.array(PartnerSimpleSchema);

export type PartnerInfo = z.infer<typeof PartnerInfoSchema>;
export type AddressSimple = z.infer<typeof AddressSimpleSchema>;
export type PartnerDetail = z.infer<typeof PartnerDetailSchema>;
export type FetchPartnersResponse = z.infer<typeof FetchPartnersResponseSchema>;
export type FetchAddressesResponse = z.infer<typeof FetchAddressesResponseSchema>;
export type FetchEnumPartnersResponse = z.infer<typeof FetchEnumPartnersResponseSchema>;
